import Page from 'pages/Page';
import {
  importAddToCartChunks,
  importAlertChunks,
  importScrollToTopChunks,
} from '../../components/Cart/Chunks/Chunks';
import MediaQueries from '../../shared/helpers/MediaQueries';
import WishlistChunk from '../../modules/InitChunks/WishlistChunk/WishlistChunk';

export default class CartEmpty extends Page {
  constructor() {
    super();
    /*
     * Primary script
     * */
    window.addEventListener(
      'load',
      () => {
        // Add to cart
        importAddToCartChunks();

        // Alert
        importAlertChunks();

        // Add Wishlist
        WishlistChunk();
      },
      { once: true, passive: true }
    );

    /*
     * Secondary script
     * */
    if (MediaQueries.mobileMedia.matches) {
      // Load files for Mobile
      document.addEventListener(
        'touchstart',
        () => {
          this.importsChunks();
        },
        { once: true, passive: true }
      );
    } else {
      // Load files for other
      this.importsChunks();
    }
  }

  private importsChunks(): void {
    // Scroll To Top
    importScrollToTopChunks();
  }
}

new CartEmpty();
